import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress } from '../../../../Fct/generics';
import { FaLink } from 'react-icons/fa';
import { FACTORY_V2_ADDRESSES } from '../constants';
export var GetPair = createPlugin({
    protocol: 'UNISWAP',
    type: 'GETTER',
    method: 'getPair',
    supportedContracts: FACTORY_V2_ADDRESSES,
    getParams: function () { return ({
        input: {
            to: new FctAddress({ destination: 'uniswap_factory' }), // TODO: Add Uniswap V2 pools to options
            methodParams: {
                tokenA: new FctAddress({ destination: 'erc20', isPreview: true, icon: FaLink }),
                tokenB: new FctAddress({ destination: 'erc20', isPreview: true }),
            },
        },
        output: {
            address: new FctAddress({ destination: 'uniswap_pool_v2', innerIndex: 0 }),
        },
    }); },
});
